import React from 'react';

const LoadingCheckIcon: React.FC = () => (
  <svg width="41" height="43" viewBox="0 0 41 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.40842 12.5613C0.611032 13.0929 0.13208 13.9878 0.13208 14.9462V39.7069C0.13208 41.2899 1.41534 42.5731 2.99832 42.5731H38.0911C39.6741 42.5731 40.9574 41.2899 40.9574 39.7069V14.9462C40.9574 13.9878 40.4784 13.0929 39.681 12.5613L22.4526 1.07571C21.2973 0.305493 19.7922 0.305493 18.6368 1.07571L1.40842 12.5613ZM29.7351 20.8179C30.8739 19.6791 30.8739 17.8327 29.7351 16.6939C28.5963 15.5551 26.7499 15.5551 25.6111 16.6939L17.8718 24.4333L15.4786 22.0401C14.3398 20.9013 12.4935 20.9013 11.3547 22.0401C10.2158 23.1789 10.2158 25.0253 11.3547 26.1641L15.8098 30.6192C16.9486 31.758 18.795 31.758 19.9338 30.6192L29.7351 20.8179Z"
      fill="#EBEBEB"
    />
  </svg>
);

export default LoadingCheckIcon;
